<template>
  <div class="keyI contentBack">
    <div class="contentBack6">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item class="breadSelected">重点产业分析 </el-breadcrumb-item>
      </el-breadcrumb>
      <div id="pdfDom">
      <!-- 1.筛选 -->
      <div class="analy">
        <!-- 选择产业 -->
        <div class="analySelect">
          <i class="iconfont">&#xe6b6;</i>
          <el-select v-model="indu" @change="changeindu">
            <el-option label="电子信息" value="电子信息"></el-option>
            <el-option label="装备制造" value="装备制造"></el-option>
            <el-option label="生物医药" value="生物医药"></el-option>
            <el-option label="能源化工" value="能源化工"></el-option>
          </el-select>
        </div>
        <!-- 选择时间 -->
        <div class="timeblock">
          <i class="iconfont">&#xe6c2;</i>
          <el-cascader
            v-model="timevalue"
            :options="options"
            @change="handleTimeChange"
          >
          </el-cascader>
        </div>
         <div class="downreport" @click="btnClick">
         <i class="iconfont">&#xe6d0;</i> 下载报告
        </div>
      </div>
      <!-- 筛选结束 -->
      <!-- 2.概况统计 -->
      <div class="keyFirmCount">
        <div class="market-one">
            <div class="market-img">
            <i class="iconfont big-icon">&#xe6bf;</i>
          </div>
             <div class="market-text">
           <p>市场主体概况</p>
          <ul>
            <li>
              市场主体数(累计)：<span>{{ count.apTotal }}</span> 家
            </li>
             <li>
              新增市场主体数：<span>{{ count.addApTotal }}</span> 家
            </li>
          </ul>
         </div>

        </div>
       <div class="market-one" style="width:40%" >
          <div class="market-img">
            <i class="iconfont big-icon">&#xe6bd;</i>
          </div>
           <div class="market-text" style="width:100%">
          <p>国内专利概况</p>
          <ul class="country-overview" >
            <li >
              国内专利申请(已公开)量：<span>{{ count.ptTotal }}</span> 件
            </li>
            <li >
              国内授权专利量：<span>{{ count.ptAuth }}</span> 件
            </li>
            <li >
              PCT专利申请(已公开)量：<span>{{ count.ptPct }}</span> 件
            </li>
          </ul>
          </div>
        
        </div>
           <div class="market-one" style="border:none;width:45%">
          <div class="market-img">
            <i class="iconfont big-icon">&#xe6be;</i>
          </div>
           <div class="market-text">
          <p>商标概况</p>
          <ul class="country-overview">
           <li>
              国内商标申请量：<span>{{ count.tmTotal }}</span> 件
            </li>
            <li>
              国内商标注册量：<span>{{ count.tmReg }}</span> 件
            </li>
            <li>
              马德里商标注册量：<span>{{ count.tmMadridReg }}</span> 件
            </li>
            <li>
              驰名商标量：<span>{{ count.tmFamous }}</span> 件
            </li>
          </ul>
          </div>
        
        </div>
  
      </div>
      <!-- 概况统计结束 -->
      <div
        style="height: 11px; width: 100%; background: #f2f2f2; margin-top: 20px"
      ></div>
      <!-- 3.专利分析 -->
      <div>
       
        <!-- 3-1.国内专利分析 -->
        <div id="domesticzlAnalyind">
           <div class="inside">
            <div class="inside-title"><div></div>国内专利分析</div>
          </div>
          <div id="main">
            <!-- 国内专利趋势 -->
            <div class="zl2">
              <div class="checkEchart">
                <div
                  @click="switchEchart(1)"
                  :class="{ checked: echartsType1 == 1 }"
                >
                  <i class="iconfont">&#xe6e0;</i>
                  <p>面积图</p>
                </div>
                <div
                  @click="switchEchart(2)"
                  :class="{ checked: echartsType1 == 2 }"
                >
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
              </div>
              <p class="biaoTitle">国内专利趋势</p>
              <div v-show="havedata1">
                <!-- 面积图 -->
                <div
                  v-show="echartsType1 == 1"
                  class="echartsBox1 domesticzl1ind"
                ></div>
                <!-- 数据视图 -->
                <div v-show="echartsType1 == 2">
                  <el-table
                    :data="trendApList"
                    border
                    stripe
                    style="width: 90%; margin: 4% auto 0"
                  >
                    <el-table-column :resizable="false" prop="name" label="时间" width="180">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="num" label="专利申请量" width="180">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="num2" label="专利授权量">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div v-show="!havedata1" class="blankimg">
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
            </div>
            <!-- 专利类型构成 -->
            <div class="zl2">
              <div class="checkEchart">
                <div
                  @click="switchEchart(3)"
                  :class="{ checked: echartsType2 == 3 }"
                >
                  <i class="iconfont">&#xe6e1;</i>
                  <p>饼状图</p>
                </div>
                <div
                  @click="switchEchart(4)"
                  :class="{ checked: echartsType2 == 4 }"
                >
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
              </div>
              <p class="biaoTitle">专利类型构成</p>
              <div class="sqSwitch">
                <button @click="applybtn(1)" :class="{ numbtn: numType1 == 1 }">
                  申请量
                </button>
                <button @click="agreebtn(2)" :class="{ numbtn: numType1 == 2 }">
                  授权量
                </button>
              </div>
              <!-- 面积图 -->
              <div
                v-show="echartsType2 == 3 && numType1 == 1 && havedata2"
                class="echartsBox1 domesticzl2ind"
              ></div>
              <div
                v-show="echartsType2 == 3 && numType1 == 1 && !havedata2"
                class="blankimg"
              >
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
              <div
                v-show="echartsType2 == 3 && numType1 == 2 && havedata3"
                class="echartsBox1 domesticzl2sqind"
              ></div>
              <div
                v-show="echartsType2 == 3 && numType1 == 2 && !havedata3"
                class="blankimg"
              >
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
              <!-- 数据视图 -->
              <div v-show="echartsType2 == 4 && numType1 == 1 && havedata2">
                <el-table
                  :data="apTyCount"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="专利类型">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="value" label="专利申请量">
                  </el-table-column>
                </el-table>
              </div>
              <div
                v-show="echartsType2 == 4 && numType1 == 1 && !havedata2"
                class="blankimg"
              >
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
              <div v-show="echartsType2 == 4 && numType1 == 2 && havedata3">
                <el-table
                  :data="apTyAuthCount"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="专利类型">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="value" label="专利授权量">
                  </el-table-column>
                </el-table>
              </div>
              <div
                v-show="echartsType2 == 4 && numType1 == 2 && !havedata3"
                class="blankimg"
              >
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
            </div>
          </div>
          <!-- IPC技术分类top10 -->
          <div class="zl2" id="ipcaaaaaa">
            <div class="checkEchart">
              <div
                @click="switchEchart(5)"
                :class="{ checked: echartsType3 == 5 }"
              >
                <i class="iconfont">&#xe6de;</i>
                <p>条形图</p>
              </div>
              <div
                @click="switchEchart(6)"
                :class="{ checked: echartsType3 == 6 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">IPC技术分类top10</p>
            <div class="sqSwitch">
              <button @click="applybtn(3)" :class="{ numbtn: numType2 == 3 }">
                申请量
              </button>
              <button @click="agreebtn(4)" :class="{ numbtn: numType2 == 4 }">
                授权量
              </button>
            </div>
            <!-- 条形图 -->
            <div
              v-show="echartsType3 == 5 && numType2 == 3 && havedata4"
              class="echartsBox1 domesticzl3ind"
            ></div>
            <div
              v-show="echartsType3 == 5 && numType2 == 3 && !havedata4"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div
              v-show="echartsType3 == 5 && numType2 == 4 && havedata5"
              class="echartsBox1 domesticzl3sqind"
            ></div>
            <div
              v-show="echartsType3 == 5 && numType2 == 4 && !havedata5"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <!-- 数据视图 -->
            <div v-show="echartsType3 == 6 && numType2 == 3 && havedata4">
              <el-table
                :data="ipcCount"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column :resizable="false" type="index" label="排序" width="50">
                </el-table-column>
                <el-table-column :resizable="false" prop="name" label="IPC技术分类">
                </el-table-column>
                <el-table-column :resizable="false" prop="num" label="专利申请量">
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType3 == 6 && numType2 == 3 && !havedata4"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div v-show="echartsType3 == 6 && numType2 == 4 && havedata5">
              <el-table
                :data="ipcAuthCount"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column :resizable="false" type="index" label="排序" width="50">
                </el-table-column>
                <el-table-column :resizable="false" prop="name" label="IPC技术分类">
                </el-table-column>
                <el-table-column :resizable="false" prop="num" label="专利申请量">
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType3 == 6 && numType2 == 4 && !havedata5"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
          <!-- 专利分析榜单 -->
          <div class="zl3">
            <div class="checkEchart">
              <div
                @click="switchEchart(7)"
                :class="{ checked: echartsType4 == 7 }"
              >
                <i class="iconfont">&#xe6de;</i>
                <p>条形图</p>
              </div>
              <div
                @click="switchEchart(8)"
                :class="{ checked: echartsType4 == 8 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">专利分析榜单</p>
            <div class="sqSwitch">
              <button @click="applybtn(5)" :class="{ numbtn: numType3 == 5 }">
                申请量
              </button>
              <button @click="agreebtn(6)" :class="{ numbtn: numType3 == 6 }">
                授权量
              </button>
              <button @click="yxfmbtn(7)" :class="{ numbtn: numType3 == 7 }">
                有效发明量(累计)
              </button>
              <button @click="wxfmbtn(8)" :class="{ numbtn: numType3 == 8 }">
                无效专利量
              </button>
            </div>
            <!-- 条形图 -->
            <div
              v-show="echartsType4 == 7 && numType3 == 5 && havedata6"
              class="echartsBox1 domesticzl4ind"
            ></div>
            <div
              v-show="echartsType4 == 7 && numType3 == 5 && !havedata6"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div
              v-show="echartsType4 == 7 && numType3 == 6 && havedata7"
              class="echartsBox1 domesticzl4sqind"
            ></div>
            <div
              v-show="echartsType4 == 7 && numType3 == 6 && !havedata7"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div
              v-show="echartsType4 == 7 && numType3 == 7 && havedata8"
              class="echartsBox1 domesticzl4yxind"
            ></div>
            <div
              v-show="echartsType4 == 7 && numType3 == 7 && !havedata8"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div
              v-show="echartsType4 == 7 && numType3 == 8 && havedata9"
              class="echartsBox1 domesticzl4wxind"
            ></div>
            <div
              v-show="echartsType4 == 7 && numType3 == 8 && !havedata9"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <!-- 数据视图 -->
            <div v-show="echartsType4 == 8 && numType3 == 5 && havedata6">
              <div class="titleBox">
                <el-button
                  @click="seeMore50(101)"
                  :disabled="appTop10.length === appTop50.length"
                  >更多</el-button
                >
                <!-- <el-button>导出</el-button> -->
              </div>
              <el-table
                :data="appTop10"
                border
                stripe
                style="width: 90%; margin: 0 auto"
              >
                <el-table-column :resizable="false" label="排序" type="index" width="50">
                </el-table-column>
                <el-table-column :resizable="false" prop="name" label="企业名称">
                </el-table-column>
                <el-table-column :resizable="false" prop="num" label="专利申请量">
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType4 == 8 && numType3 == 5 && !havedata6"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div v-show="echartsType4 == 8 && numType3 == 6 && havedata7">
              <div class="titleBox">
                <el-button
                  @click="seeMore50(102)"
                  :disabled="authTop50.length === authTop10.length"
                  >更多</el-button
                >
                <!-- <el-button>导出</el-button> -->
              </div>
              <el-table
                :data="authTop10"
                border
                stripe
                style="width: 90%; margin: 0 auto"
              >
                <el-table-column :resizable="false" label="排序" type="index" width="50">
                </el-table-column>
                <el-table-column :resizable="false" prop="name" label="企业名称">
                </el-table-column>
                <el-table-column :resizable="false" prop="num" label="专利授权量">
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType4 == 8 && numType3 == 6 && !havedata7"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div v-show="echartsType4 == 8 && numType3 == 7 && havedata8">
              <div class="titleBox">
                <el-button
                  @click="seeMore50(103)"
                  :disabled="validTop10.length === validTop50.length"
                  >更多</el-button
                >
                <!-- <el-button>导出</el-button> -->
              </div>
              <el-table
                :data="validTop10"
                border
                stripe
                style="width: 90%; margin: 0 auto"
              >
                <el-table-column :resizable="false" label="排序" type="index" width="50">
                </el-table-column>
                <el-table-column :resizable="false" prop="name" label="企业名称">
                </el-table-column>
                <el-table-column :resizable="false" prop="num" label="有效发明量(累计)">
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType4 == 8 && numType3 == 7 && !havedata8"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div v-show="echartsType4 == 8 && numType3 == 8 && havedata9">
              <div class="titleBox">
                <el-button
                  @click="seeMore50(104)"
                  :disabled="notValidTop10.length === notValidTop50.length"
                  >更多</el-button
                >
                <!-- <el-button>导出</el-button> -->
              </div>
              <el-table
                :data="notValidTop10"
                border
                stripe
                style="width: 90%; margin: 0 auto"
              >
                <el-table-column :resizable="false" label="排序" type="index" width="50">
                </el-table-column>
                <el-table-column :resizable="false" prop="name" label="企业名称">
                </el-table-column>
                <el-table-column :resizable="false" prop="num" label="无效专利量">
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType4 == 8 && numType3 == 8 && !havedata9"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
        </div>
        <!-- 3-2.PCT公开专利分析 -->
        <div id="PCTAnalyind">
          <div class="inside">
            <div class="inside-title"><div></div>PCT公开专利分析</div>
          </div>
          <!-- <div style="display: flex; justify-content: space-between"> -->
            <!-- PCT专利趋势 -->
            <div class="zl2">
              <div class="checkEchart">
                <div
                  @click="switchEchart(9)"
                  :class="{ checked: echartsType5 == 9 }"
                >
                  <i class="iconfont">&#xe6e0;</i>
                  <p>面积图</p>
                </div>
                <div
                  @click="switchEchart(10)"
                  :class="{ checked: echartsType5 == 10 }"
                >
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
              </div>
              <p class="biaoTitle">PCT专利趋势</p>
              <div v-show="havedata10">
                <!-- 面积图 -->
                <div
                  v-show="echartsType5 == 9"
                  class="echartsBox1 pctzl1ind"
                ></div>
                <!-- 数据视图 -->
                <div v-show="echartsType5 == 10">
                  <el-table
                    :data="pctTrendCount"
                    border
                    stripe
                    style="width: 90%; margin: 4% auto 0"
                  >
                    <el-table-column :resizable="false" prop="name" label="时间">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="num" label="公开量">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div v-show="!havedata10" class="blankimg">
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
            </div>
            <!-- IPC分类Top10 -->
            <div class="zl2">
              <div class="checkEchart">
                <div
                  @click="switchEchart(11)"
                  :class="{ checked: echartsType6 == 11 }"
                >
                  <i class="iconfont">&#xe6de;</i>
                  <p>条形图</p>
                </div>
                <div
                  @click="switchEchart(12)"
                  :class="{ checked: echartsType6 == 12 }"
                >
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
              </div>
              <p class="biaoTitle">IPC分类Top10</p>
              <div v-show="havedata11">
                <!-- 条形图 -->
                <div
                  v-show="echartsType6 == 11"
                  class="echartsBox3 pctzl2ind"
                ></div>
                <!-- 数据视图 -->
                <div v-show="echartsType6 == 12">
                  <el-table
                    :data="pctIpcTop10"
                    border
                    stripe
                    style="width: 90%; margin: 4% auto 0"
                  >
                    <el-table-column :resizable="false" label="排序" type="index" width="50">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="name" label="IPC分类">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="num" label="申请量">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div v-show="!havedata11" class="blankimg">
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
            </div>
          <!-- </div> -->
          <!-- PCT公开量Top10 -->
          <div class="zl6">
            <div class="checkEchart">
              <div
                @click="switchEchart(13)"
                :class="{ checked: echartsType7 == 13 }"
              >
                <i class="iconfont">&#xe6de;</i>
                <p>条形图</p>
              </div>
              <div
                @click="switchEchart(14)"
                :class="{ checked: echartsType7 == 14 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">PCT公开量Top10</p>
            <div v-show="havedata12">
              <!-- 条形图 -->
              <div
                v-show="echartsType7 == 13"
                class="echartsBox1 pctzl3ind"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType7 == 14">
                <div class="titleBox">
                  <el-button
                    @click="seeMore50(105)"
                    :disabled="pctTop10Count.length === pctTop50Count.length"
                    >更多</el-button
                  >
                  <!-- <el-button>导出</el-button> -->
                </div>
                <el-table
                  :data="pctTop10Count"
                  border
                  stripe
                  style="width: 90%; margin: 0 auto"
                >
                  <el-table-column :resizable="false" label="排序" type="index" width="50">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="name" label="企业名称">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="公开量"> </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata12" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
          <!-- 3-3.专利状态分析-->
          <div id="zlStatusAnalyind">
            <div class="inside">
            <div class="inside-title"><div></div>专利状态分析</div>
          </div>
            <!-- 专利状态分析 -->
            <div class="zl7">
              <div class="checkEchart">
                <div
                  @click="switchEchart(15)"
                  :class="{ checked: echartsType8 == 15 }"
                >
                  <i class="iconfont">&#xe6e1;</i>
                  <p>饼状图</p>
                </div>
                <div
                  @click="switchEchart(16)"
                  :class="{ checked: echartsType8 == 16 }"
                >
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
              </div>
              <p class="biaoTitle2">专利状态分析</p>
              <div v-show="havedata13">
                <!-- 饼状图 -->
                <div
                  v-show="echartsType8 == 15"
                  class="echartsBox1 statuszlind"
                ></div>
                <!-- 数据视图 -->
                <div v-show="echartsType8 == 16">
                  <el-table
                    :data="ptLawCount"
                    border
                    stripe
                    style="width: 90%; margin: 4% auto 0"
                  >
                    <el-table-column :resizable="false" prop="name" label="法律状态">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="num" label="专利量">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div v-show="!havedata13" class="blankimg">
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 专利分析结束 -->
      <div
        style="height: 30px; width: 100%; background: #f2f2f2; margin-top: 20px"
      ></div>
      <!-- 4.商标分析 -->
      <div>
       

        <!-- 4-1.国内商标分析 -->
        <div id="domesticsbAnalyind">
           <div class="inside">
            <div class="inside-title"><div></div>国内商标分析</div>
          </div>
          <!-- <div style="display: flex; justify-content: space-between"> -->
            <!-- 国内商标趋势 -->
            <div class="sb3">
              <div class="checkEchart">
                <div
                  @click="switchEchart(17)"
                  :class="{ checked: echartsType9 == 17 }"
                >
                  <i class="iconfont">&#xe6e0;</i>
                  <p>面积图</p>
                </div>
                <div
                  @click="switchEchart(18)"
                  :class="{ checked: echartsType9 == 18 }"
                >
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
              </div>
              <p class="biaoTitle">国内商标趋势</p>
              <div v-show="havedata14">
                <!-- 面积图 -->
                <div
                  v-show="echartsType9 == 17"
                  class="echartsBox1 domesticsb1ind"
                ></div>
                <!-- 数据视图 -->
                <div v-show="echartsType9 == 18">
                  <el-table
                    :data="tmTrendMap"
                    border
                    stripe
                    style="width: 90%; margin: 4% auto 0"
                  >
                    <el-table-column :resizable="false" prop="name" label="时间">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="num" label="申请量">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="num2" label="注册量">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div v-show="!havedata14" class="blankimg">
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
            </div>
            <!-- 国际分类Top10 -->
            <div class="sb4">
              <div class="checkEchart">
                <div
                  @click="switchEchart(19)"
                  :class="{ checked: echartsType10 == 19 }"
                >
                  <i class="iconfont">&#xe6de;</i>
                  <p>条形图</p>
                </div>
                <div
                  @click="switchEchart(20)"
                  :class="{ checked: echartsType10 == 20 }"
                >
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
              </div>
              <p class="biaoTitle">国际分类Top10</p>
              <div class="sqSwitch">
                <button @click="applybtn(9)" :class="{ numbtn: numType4 == 9 }">
                  申请量
                </button>
                <button @click="regbtn(10)" :class="{ numbtn: numType4 == 10 }">
                  注册量
                </button>
              </div>
              <!-- 条形图 -->
              <div
                v-show="echartsType10 == 19 && numType4 == 9 && havedata15"
                class="echartsBox1 domesticsb2ind"
              ></div>
              <div
                v-show="echartsType10 == 19 && numType4 == 9 && !havedata15"
                class="blankimg"
              >
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
              <div
                v-show="echartsType10 == 19 && numType4 == 10 && havedata16"
                class="echartsBox1 domesticsb2zcind"
              ></div>
              <div
                v-show="echartsType10 == 19 && numType4 == 10 && !havedata16"
                class="blankimg"
              >
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
              <!-- 数据视图 -->
              <div v-show="echartsType10 == 20 && numType4 == 9 && havedata15">
                <el-table
                  :data="icTop10Map"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column :resizable="false" type="index" label="排序" width="50">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="IC" label="国际分类">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="申请量"> </el-table-column>
                </el-table>
              </div>
              <div
                v-show="echartsType10 == 20 && numType4 == 9 && !havedata15"
                class="blankimg"
              >
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
              <div v-show="echartsType10 == 20 && numType4 == 10 && havedata16">
                <el-table
                  :data="icRegTop10Map"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column :resizable="false" type="index" label="排序" width="50">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="IC" label="国际分类">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="注册量"> </el-table-column>
                </el-table>
              </div>
              <div
                v-show="echartsType10 == 20 && numType4 == 10 && !havedata16"
                class="blankimg"
              >
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
            </div>
          <!-- </div> -->
          <!--商标分析榜单  -->
          <div class="sb3">
            <div class="checkEchart">
              <div
                @click="switchEchart(21)"
                :class="{ checked: echartsType11 == 21 }"
              >
                <i class="iconfont">&#xe6de;</i>
                <p>条形图</p>
              </div>
              <div
                @click="switchEchart(22)"
                :class="{ checked: echartsType11 == 22 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">商标分析榜单</p>
            <div class="sqSwitch">
              <button @click="applybtn(11)" :class="{ numbtn: numType5 == 11 }">
                申请量
              </button>
              <button @click="regbtn(12)" :class="{ numbtn: numType5 == 12 }">
                注册量
              </button>
              <button @click="yxregbtn(13)" :class="{ numbtn: numType5 == 13 }">
                有效注册量
              </button>
            </div>
            <!-- 条形图 -->
            <div
              v-show="echartsType11 == 21 && numType5 == 11 && havedata17"
              class="echartsBox1 domesticsb3ind"
            ></div>
            <div
              v-show="echartsType11 == 21 && numType5 == 11 && !havedata17"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div
              v-show="echartsType11 == 21 && numType5 == 12 && havedata18"
              class="echartsBox1 domesticsb3zcind"
            ></div>
            <div
              v-show="echartsType11 == 21 && numType5 == 12 && !havedata18"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div
              v-show="echartsType11 == 21 && numType5 == 13 && havedata19"
              class="echartsBox1 domesticsb3yxind"
            ></div>
            <div
              v-show="echartsType11 == 21 && numType5 == 13 && !havedata19"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <!-- 数据视图 -->
            <div v-show="echartsType11 == 22 && numType5 == 11 && havedata17">
              <div class="titleBox">
                <el-button
                  @click="seeMore50(106)"
                  :disabled="topApp50Map.length === topApp50Map.length"
                  >更多</el-button
                >
              </div>
              <el-table
                :data="topApp10Map"
                border
                stripe
                style="width: 90%; margin: 0 auto"
              >
                <el-table-column :resizable="false" type="index" label="排序" width="50">
                </el-table-column>
                <el-table-column :resizable="false" prop="name" label="企业名称">
                </el-table-column>
                <el-table-column :resizable="false" prop="num" label="申请量"> </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType11 == 22 && numType5 == 11 && !havedata17"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div v-show="echartsType11 == 22 && numType5 == 12 && havedata18">
              <div class="titleBox">
                <el-button
                  @click="seeMore50(107)"
                  :disabled="topReg50Map.length === topReg50Map.length"
                  >更多</el-button
                >
              </div>
              <el-table
                :data="topReg10Map"
                border
                stripe
                style="width: 90%; margin: 0 auto"
              >
                <el-table-column :resizable="false" type="index" label="排序" width="50">
                </el-table-column>
                <el-table-column :resizable="false" prop="name" label="企业名称">
                </el-table-column>
                <el-table-column :resizable="false" prop="num" label="注册量"> </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType11 == 22 && numType5 == 12 && !havedata18"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div v-show="echartsType11 == 22 && numType5 == 13 && havedata19">
              <div class="titleBox">
                <el-button
                  @click="seeMore50(108)"
                  :disabled="topValid50Map.length === topValid50Map.length"
                  >更多</el-button
                >
                <!-- <el-button>导出</el-button> -->
              </div>
              <el-table
                :data="topValid10Map"
                border
                stripe
                style="width: 90%; margin: 0 auto"
              >
                <el-table-column :resizable="false" type="index" label="排序" width="50">
                </el-table-column>
                <el-table-column :resizable="false" prop="name" label="企业名称">
                </el-table-column>
                <el-table-column :resizable="false" prop="num" label="有效注册量">
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType11 == 22 && numType5 == 13 && !havedata19"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
        </div>
        <!-- 4-2.马德里商标分析 -->
        <div id="mdlAnalyind">
           <div class="inside">
            <div class="inside-title"><div></div>马德里商标分析</div>
          </div>
          <!-- 马德里商标趋势 -->
          <div class="sb4">
            <div class="checkEchart">
              <div
                @click="switchEchart(23)"
                :class="{ checked: echartsType12 == 23 }"
              >
                <i class="iconfont">&#xe6e0;</i>
                <p>面积图</p>
              </div>
              <div
                @click="switchEchart(24)"
                :class="{ checked: echartsType12 == 24 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">马德里商标趋势</p>
            <div v-show="havedata20">
              <!-- 面积图 -->
              <div
                v-show="echartsType12 == 23"
                class="echartsBox1 mdl1ind"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType12 == 24">
                <el-table
                  :data="madridTrend"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="时间"> </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="马德里注册量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata20" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
          <!-- 马德里延伸国家TOP20 -->
          <div class="sb5">
            <div class="checkEchart">
              <div
                @click="switchEchart(25)"
                :class="{ checked: echartsType13 == 25 }"
              >
                <i class="iconfont">&#xe6df;</i>
                <p>柱状图</p>
              </div>
              <div
                @click="switchEchart(26)"
                :class="{ checked: echartsType13 == 26 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">马德里延伸国家TOP20</p>
            <div v-show="havedata21">
              <!-- 柱状图 -->
              <div
                v-show="echartsType13 == 25"
                class="echartsBox1 mdl2ind"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType13 == 26">
                <div style="display: flex; margin: 4% auto 0; width: 70%">
                  <el-table :data="madridExtendTop201" border stripe>
                    <el-table-column :resizable="false"
                      type="index"
                      label="排序"
                      width="60"
                    ></el-table-column>
                    <el-table-column :resizable="false" prop="name" label="马德里延伸国家">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="num" label="马德里注册量">
                    </el-table-column>
                  </el-table>
                  <el-table :data="madridExtendTop202" border stripe>
                    <el-table-column :resizable="false" type="index" label="排序" width="60">
                      <template slot-scope="scope">
                        <span>{{ scope.$index + 11 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column :resizable="false" prop="name" label="马德里延伸国家">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="num" label="马德里注册量">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div v-show="!havedata21" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
          <!-- 马德里注册量Top10 -->
          <div class="sb6">
            <div class="checkEchart">
              <div
                @click="switchEchart(27)"
                :class="{ checked: echartsType14 == 27 }"
              >
                <i class="iconfont">&#xe6de;</i>
                <p>条形图</p>
              </div>
              <div
                @click="switchEchart(28)"
                :class="{ checked: echartsType14 == 28 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">马德里注册量Top10</p>
            <div v-show="havedata22">
              <!-- 条形图 -->
              <div
                v-show="echartsType14 == 27"
                class="echartsBox1 mdl3ind"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType14 == 28">
                <div class="titleBox">
                  <el-button
                    @click="seeMore50(112)"
                    :disabled="madridTop10.length === madridTop50.length"
                    >更多</el-button
                  >
                </div>
                <el-table
                  :data="madridTop10"
                  border
                  stripe
                  style="width: 90%; margin: 0 auto"
                >
                  <el-table-column :resizable="false"
                    type="index"
                    label="排序"
                    width="60"
                  ></el-table-column>
                  <el-table-column :resizable="false" prop="name" label="企业名称">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="马德里注册量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata22" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
        </div>
        <!-- 4-3.商标状态分析 -->
        <div id="sbStatusAnalyind">
           <div class="inside">
            <div class="inside-title"><div></div>商标状态分析</div>
          </div>
          <!-- 商标状态分析 -->
          <div class="sb7">
            <div class="checkEchart">
              <div
                @click="switchEchart(29)"
                :class="{ checked: echartsType15 == 29 }"
              >
                <i class="iconfont">&#xe6e1;</i>
                <p>饼状图</p>
              </div>
              <div
                @click="switchEchart(30)"
                :class="{ checked: echartsType15 == 30 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">商标状态分析</p>
            <div v-show="havedata23">
              <!-- 饼状图 -->
              <div
                v-show="echartsType15 == 29"
                class="echartsBox1 statussbind"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType15 == 30">
                <el-table
                  :data="lawMap"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column :resizable="false" prop="ls" label="法律状态">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="商标量"> </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata23" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
        </div>
        <!-- 4-4.商标运营分析 -->
        <div id="sbOperationAnalyind">
         <div class="inside">
            <div class="inside-title"><div></div>商标状态分析</div>
          </div>
          <!-- <div style="display: flex; justify-content: space-between"> -->
            <!-- 商标转让趋势 -->
            <div class="sb8">
              <div class="checkEchart">
                <div
                  @click="switchEchart(31)"
                  :class="{ checked: echartsType16 == 31 }"
                >
                  <i class="iconfont">&#xe6e0;</i>
                  <p>面积图</p>
                </div>
                <div
                  @click="switchEchart(32)"
                  :class="{ checked: echartsType16 == 32 }"
                >
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
              </div>
              <p class="biaoTitle">商标转让趋势</p>
              <div v-show="havedata24">
                <!-- 面积图 -->
                <div
                  v-show="echartsType16 == 31"
                  class="echartsBox1 sbmani1ind"
                ></div>
                <!-- 数据视图 -->
                <div v-show="echartsType16 == 32">
                  <el-table
                    :data="tmTransferMap"
                    border
                    stripe
                    style="width: 90%; margin: 4% auto 0"
                  >
                    <el-table-column :resizable="false" prop="name" label="时间">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="num" label="转让量">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div v-show="!havedata24" class="blankimg">
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
            </div>
            <!-- 商标转让类别Top10 -->
            <div class="sb8">
              <div class="checkEchart">
                <div
                  @click="switchEchart(33)"
                  :class="{ checked: echartsType17 == 33 }"
                >
                  <i class="iconfont">&#xe6de;</i>
                  <p>条形图</p>
                </div>
                <div
                  @click="switchEchart(34)"
                  :class="{ checked: echartsType17 == 34 }"
                >
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
              </div>
              <p class="biaoTitle">商标转让类别Top10</p>
              <div v-show="havedata25">
                <!-- 条形图 -->
                <div
                  v-show="echartsType17 == 33"
                  class="echartsBox1 sbmani2ind"
                ></div>
                <!-- 数据视图 -->
                <div v-show="echartsType17 == 34">
                  <el-table
                    :data="tmIcTrfTop"
                    border
                    stripe
                    style="width: 90%; margin: 4% auto 0"
                  >
                    <el-table-column :resizable="false" type="index" label="排序" width="50">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="name" label="国际分类">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="num" label="转让量">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div v-show="!havedata25" class="blankimg">
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
            </div>
          <!-- </div> -->
          <!-- <div style="display: flex; justify-content: space-between"> -->
            <!--商标许可趋势  -->
            <div class="sb8">
              <div class="checkEchart">
                <div
                  @click="switchEchart(35)"
                  :class="{ checked: echartsType18 == 35 }"
                >
                  <i class="iconfont">&#xe6e0;</i>
                  <p>面积图</p>
                </div>
                <div
                  @click="switchEchart(36)"
                  :class="{ checked: echartsType18 == 36 }"
                >
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
              </div>
              <p class="biaoTitle">商标许可趋势</p>
              <div v-show="havedata26">
                <!-- 面积图 -->
                <div
                  v-show="echartsType18 == 35"
                  class="echartsBox1 sbmani3ind"
                ></div>
                <!-- 数据视图 -->
                <div v-show="echartsType18 == 36">
                  <el-table
                    :data="tmLicenseMap"
                    border
                    stripe
                    style="width: 90%; margin: 4% auto 0"
                  >
                    <el-table-column :resizable="false" prop="name" label="时间">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="num" label="许可量">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div v-show="!havedata26" class="blankimg">
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
            </div>

            <!-- 商标许可类别Top10 -->
            <div class="sb8">
              <div class="checkEchart">
                <div
                  @click="switchEchart(37)"
                  :class="{ checked: echartsType19 == 37 }"
                >
                  <i class="iconfont">&#xe6de;</i>
                  <p>条形图</p>
                </div>
                <div
                  @click="switchEchart(38)"
                  :class="{ checked: echartsType19 == 38 }"
                >
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
              </div>
              <p class="biaoTitle">商标许可类别Top10</p>
              <div v-show="havedata27">
                <!-- 条形图 -->
                <div
                  v-show="echartsType19 == 37"
                  class="echartsBox1 sbmani4ind"
                ></div>
                <!-- 数据视图 -->
                <div v-show="echartsType19 == 38">
                  <el-table
                    :data="tmIcLicTop"
                    border
                    stripe
                    style="width: 90%; margin: 4% auto 0"
                  >
                    <el-table-column :resizable="false" type="index" label="排序" width="50">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="name" label="国际分类">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="num" label="许可量">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div v-show="!havedata27" class="blankimg">
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
            </div>
          <!-- </div> -->
          <!-- <div style="display: flex; justify-content: space-between"> -->
            <!-- 商标质押趋势 -->
            <div class="sb8">
              <div class="checkEchart">
                <div
                  @click="switchEchart(39)"
                  :class="{ checked: echartsType20 == 39 }"
                >
                  <i class="iconfont">&#xe6e0;</i>
                  <p>面积图</p>
                </div>
                <div
                  @click="switchEchart(40)"
                  :class="{ checked: echartsType20 == 40 }"
                >
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
              </div>
              <p class="biaoTitle">商标质押趋势</p>
              <div v-show="havedata28">
                <!-- 面积图 -->
                <div
                  v-show="echartsType20 == 39"
                  class="echartsBox1 sbmani5ind"
                ></div>
                <!-- 数据视图 -->
                <div v-show="echartsType20 == 40">
                  <el-table
                    :data="tmPledgeMap"
                    border
                    stripe
                    style="width: 90%; margin: 4% auto 0"
                  >
                    <el-table-column :resizable="false" prop="name" label="时间">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="num" label="质押量">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div v-show="!havedata28" class="blankimg">
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
            </div>

            <!-- 商标质押类别Top10 -->
            <div class="sb8">
              <div class="checkEchart">
                <div
                  @click="switchEchart(41)"
                  :class="{ checked: echartsType21 == 41 }"
                >
                  <i class="iconfont">&#xe6de;</i>
                  <p>条形图</p>
                </div>
                <div
                  @click="switchEchart(42)"
                  :class="{ checked: echartsType21 == 42 }"
                >
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
              </div>
              <p class="biaoTitle">商标质押类别Top10</p>
              <div v-show="havedata29">
                <!-- 条形图 -->
                <div
                  v-show="echartsType21 == 41"
                  class="echartsBox1 sbmani6ind"
                ></div>
                <!-- 数据视图 -->
                <div v-show="echartsType21 == 42">
                  <el-table
                    :data="tmIcPldTop"
                    border
                    stripe
                    style="width: 90%; margin: 4% auto 0"
                  >
                    <el-table-column :resizable="false" type="index" label="排序" width="50">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="name" label="国际分类">
                    </el-table-column>
                    <el-table-column :resizable="false" prop="num" label="质押量">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div v-show="!havedata29" class="blankimg">
                <img src="../assets/imgs/blankIMG.png" />
                <p>暂无数据</p>
              </div>
            </div>
          <!-- </div> -->
          <!-- 商标运营分析榜单 -->
          <div class="sb8">
            <div class="checkEchart">
              <div
                @click="switchEchart(43)"
                :class="{ checked: echartsType22 == 43 }"
              >
                <i class="iconfont">&#xe6de;</i>
                <p>条形图</p>
              </div>
              <div
                @click="switchEchart(44)"
                :class="{ checked: echartsType22 == 44 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">商标运营分析榜单</p>
            <div class="sqSwitch">
              <button @click="applybtn(14)" :class="{ numbtn: numType6 == 14 }">
                商标转让量
              </button>
              <button @click="agreebtn(15)" :class="{ numbtn: numType6 == 15 }">
                商标许可量
              </button>
              <button @click="yxregbtn(16)" :class="{ numbtn: numType6 == 16 }">
                商标质押量
              </button>
            </div>
            <!-- 条形图 -->
            <div
              v-show="echartsType22 == 43 && numType6 == 14 && havedata30"
              class="echartsBox1 sbmani7ind"
            ></div>
            <div
              v-show="echartsType22 == 43 && numType6 == 14 && !havedata30"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div
              v-show="echartsType22 == 43 && numType6 == 15 && havedata31"
              class="echartsBox1 sbmani7xkind"
            ></div>
            <div
              v-show="echartsType22 == 43 && numType6 == 15 && !havedata31"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div
              v-show="echartsType22 == 43 && numType6 == 16 && havedata32"
              class="echartsBox1 sbmani7zyind"
            ></div>
            <div
              v-show="echartsType22 == 43 && numType6 == 16 && !havedata32"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <!-- 数据视图 -->
            <div v-show="echartsType22 == 44 && numType6 == 14 && havedata30">
              <div class="titleBox">
                <el-button
                  @click="seeMore50(109)"
                  :disabled="tmTrfTop10.length === tmTrfTop50.length"
                  >更多</el-button
                >
                <!-- <el-button>导出</el-button> -->
              </div>
              <el-table
                :data="tmTrfTop10"
                border
                stripe
                style="width: 90%; margin: 0 auto"
              >
                <el-table-column :resizable="false" label="排序" type="index" width="50">
                </el-table-column>
                <el-table-column :resizable="false" prop="name" label="企业名称">
                </el-table-column>
                <el-table-column :resizable="false" prop="num" label="商标转让量">
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType22 == 44 && numType6 == 14 && !havedata30"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div v-show="echartsType22 == 44 && numType6 == 15 && havedata31">
              <div class="titleBox">
                <el-button
                  @click="seeMore50(110)"
                  :disabled="tmLicTop10.length === tmLicTop50.length"
                  >更多</el-button
                >
                <!-- <el-button>导出</el-button> -->
              </div>
              <el-table
                :data="tmLicTop10"
                border
                stripe
                style="width: 90%; margin: 0 auto"
              >
                <el-table-column :resizable="false" label="排序" type="index" width="50">
                </el-table-column>
                <el-table-column :resizable="false" prop="name" label="企业名称">
                </el-table-column>
                <el-table-column :resizable="false" prop="num" label="商标许可量">
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType22 == 44 && numType6 == 15 && !havedata31"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div v-show="echartsType22 == 44 && numType6 == 16 && havedata32">
              <div class="titleBox">
                <el-button
                  @click="seeMore50(111)"
                  :disabled="tmPldTop10.length === tmPldTop50.length"
                  >更多</el-button
                >
                <!-- <el-button>导出</el-button> -->
              </div>
              <el-table
                :data="tmPldTop10"
                border
                stripe
                style="width: 90%; margin: 0 auto"
              >
                <el-table-column :resizable="false" label="排序" type="index" width="50">
                </el-table-column>
                <el-table-column :resizable="false" prop="name" label="企业名称">
                </el-table-column>
                <el-table-column :resizable="false" prop="num" label="商标质押量">
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType22 == 44 && numType6 == 16 && !havedata32"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
        </div>
      </div>
      </div>
      <!-- 商标分析结束 -->
    </div>
    <!-- ****右边定位box -->
    <div
      class="positionBox"
      :class="{ cotrolshow: ispositionBox, cotrolnotshow: !ispositionBox }"
    >
      <div
        class="positionBoxCotrol"
        @click="positionBoxShow"
        :class="{ turnLeft11: ispositionBox }"
      >
        <i
          :class="{ arrowrotate: ispositionBox, norotate: !ispositionBox }"
          class="el-icon-arrow-right"
        ></i>
        <i
          :class="{ arrowrotate: ispositionBox, norotate: !ispositionBox }"
          class="el-icon-arrow-right"
        ></i>
      </div>
      <div style="position: relative">
        <p>专利分析</p>
        <a
          :class="{ visited: avisit == 1 }"
          @click="turnAstyle(1, '#domesticzlAnalyind')"
          >国内专利分析</a
        >
        <a
          :class="{ visited: avisit == 7 }"
          @click="turnAstyle(7, '#PCTAnalyind')"
          >PCT公开专利分析</a
        >
        <a
          :class="{ visited: avisit == 2 }"
          @click="turnAstyle(2, '#zlStatusAnalyind')"
          >专利状态分析</a
        >
        <p>商标分析</p>
        <a
          :class="{ visited: avisit == 3 }"
          @click="turnAstyle(3, '#domesticsbAnalyind')"
          >国内商标分析</a
        >
        <a
          :class="{ visited: avisit == 4 }"
          @click="turnAstyle(4, '#mdlAnalyind')"
          >马德里商标分析</a
        >
        <a
          :class="{ visited: avisit == 5 }"
          @click="turnAstyle(5, '#sbStatusAnalyind')"
          >商标状态分析</a
        >
        <a
          :class="{ visited: avisit == 6 }"
          @click="turnAstyle(6, '#sbOperationAnalyind')"
          >商标运营分析</a
        >
      </div>
    </div>
    <!-- ****点击更多弹框 -->
    <div v-if="seeMore" class="popBoxMask"></div>
    <div v-if="seeMore" class="popBox">
      <div class="boxHeader">
        {{ label50 }}排名
        <i class="el-icon-close" @click="closeMore"> </i>
      </div>
      <div class="boxContent">
        <div class="titleBox" style="width: 100%; margin-top: 0">
          <span
            style="
              font-size: 18px;
              color: #000;
              text-align: left;
              margin-left: 28px;
              line-height: 50px;
              font-weight: bold;
            "
            >{{ label50 }}Top50</span
          >
          <el-button @click="daochu(label50)">导出Excel</el-button>
        </div>
        <el-table :data="tableData50" border style="width: 100%">
          <el-table-column :resizable="false" type="index" label="序号" width="60">
          </el-table-column>
          <el-table-column :resizable="false" prop="name" label="企业名称"> </el-table-column>
          <el-table-column :resizable="false" prop="num" :label="label50"> </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { Loading } from "element-ui";
import keyIndustries from "../assets/js/diagrams/keyIndustries.js";
export default {
  data() {
    return {
      // exportPDFtitle: this.exportPDFtitle,
      exportPDFtitle:'重点产业分析报告',
      indu: "电子信息",
      options: [
        {
          value: "2021",
          label: "2021年",
          children: [
            {
              value: "",
              label: "全部",
            },
            {
              value: "1",
              label: "第一季度",
            },
            {
              value: "2",
              label: "第二季度",
            },
            {
              value: "3",
              label: "第三季度",
            },
            {
              value: "4",
              label: "第四季度",
            },
          ],
        },
        {
          value: "2020",
          label: "2020年",
          children: [
            {
              value: "",
              label: "全部",
            },
            {
              value: "1",
              label: "第一季度",
            },
            {
              value: "2",
              label: "第二季度",
            },
            {
              value: "3",
              label: "第三季度",
            },
            {
              value: "4",
              label: "第四季度",
            },
          ],
        },
      ],
      timevalue: [],
      timevalueS: "",

      ispositionBox: false,
      avisit: 0,
      echartsType1: 1,
      echartsType2: 3,
      echartsType3: 5,
      echartsType4: 7,
      echartsType5: 9,
      echartsType6: 11,
      echartsType7: 13,
      echartsType8: 15,
      echartsType9: 17,
      echartsType10: 19,
      echartsType11: 21,
      echartsType12: 23,
      echartsType13: 25,
      echartsType14: 27,
      echartsType15: 29,
      echartsType16: 31,
      echartsType17: 33,
      echartsType18: 35,
      echartsType19: 37,
      echartsType20: 39,
      echartsType21: 41,
      echartsType22: 43,
      seeMore: false,
      numType1: 1,
      numType2: 3,
      numType3: 5,
      numType4: 9,
      numType5: 11,
      numType6: 14,
      firstscroll1: true,
      firstscroll2: true,
      firstscroll3: true,
      firstscroll4: true,
      count: {},
      trendApList: [],
      apTyCount: [],
      apTyAuthCount: [],
      appTop10: [],
      authTop10: [],
      validTop10: [],
      notValidTop10: [],
      appTop50: [],
      authTop50: [],
      validTop50: [],
      notValidTop50: [],
      pctIpcTop10: [],
      trendTime: this.$store.state.trendTime,
      pctTrendCount: [],
      ipcCount: [],
      ipcAuthCount: [],
      pctTop10Count: [],
      pctTop50Count: [],
      tmTrendMap: [],
      ptLawCount: [],
      icTop10Map: [],
      icRegTop10Map: [],
      topApp10Map: [],
      topReg10Map: [],
      topValid10Map: [],
      topApp50Map: [],
      topReg50Map: [],
      topValid50Map: [],
      tableData50: [],
      lawMap: [],
      tmTransferMap: [],
      tmIcTrfTop: [],
      tmLicenseMap: [],
      tmIcLicTop: [],
      tmPledgeMap: [],
      tmIcPldTop: [],
      tmTrfTop10: [],
      tmLicTop10: [],
      tmPldTop10: [],
      tmTrfTop50: [],
      tmLicTop50: [],
      tmPldTop50: [],
      label50: "",
      madridTrend: [],
      madridExtendTop201: [],
      madridExtendTop202: [],
      madridTop50: [],
      madridTop10: [],
      havedata1: true,
      havedata2: true,
      havedata3: true,
      havedata4: true,
      havedata5: true,
      havedata6: true,
      havedata7: true,
      havedata8: true,
      havedata9: true,
      havedata10: true,
      havedata11: true,
      havedata12: true,
      havedata13: true,
      havedata14: true,
      havedata15: true,
      havedata16: true,
      havedata17: true,
      havedata18: true,
      havedata19: true,
      havedata20: true,
      havedata21: true,
      havedata22: true,
      havedata23: true,
      havedata24: true,
      havedata25: true,
      havedata26: true,
      havedata27: true,
      havedata28: true,
      havedata29: true,
      havedata30: true,
      havedata31: true,
    };
  },
  methods: {
     // 下载报告
      btnClick() {
      this.$nextTick(() => {
        this.getPdf()
      })
    },
    changeindu(val) {
      this.indu = val;
      this.getzl();
      this.getGNzl();
      this.firstscroll1 = true;
      this.firstscroll2 = true;
      this.firstscroll3 = true;
      this.firstscroll4 = true;
      this.scrollHandle();
    },
    //   控制定位box
    positionBoxShow() {
      this.ispositionBox = this.ispositionBox ? false : true;
      if (this.ispositionBox == false) {
        this.avisit = 0;
      }
    },
    turnAstyle(value, idName) {
      this.avisit = value;
      document.querySelector(idName).scrollIntoView(true);
    },

    // 选择时间
    handleTimeChange(value) {
      this.timevalueS = value.join("");
      this.getzl();
      this.getGNzl();
      this.firstscroll1 = true;
      this.firstscroll2 = true;
      this.firstscroll3 = true;
      this.firstscroll4 = true;
      this.scrollHandle();
    },
    // 切换图标
    switchEchart(value) {
      switch (value) {
        case 1:
          this.echartsType1 = 1;
          break;
        case 2:
          this.echartsType1 = 2;
          break;
        case 3:
          this.echartsType2 = 3;
          break;
        case 4:
          this.echartsType2 = 4;
          break;
        case 5:
          this.echartsType3 = 5;
          break;
        case 6:
          this.echartsType3 = 6;
          break;
        case 7:
          this.echartsType4 = 7;
          break;
        case 8:
          this.echartsType4 = 8;
          break;
        case 9:
          this.echartsType5 = 9;
          break;
        case 10:
          this.echartsType5 = 10;
          break;
        case 11:
          this.echartsType6 = 11;
          break;
        case 12:
          this.echartsType6 = 12;
          break;
        case 13:
          this.echartsType7 = 13;
          break;
        case 14:
          this.echartsType7 = 14;
          break;
        case 15:
          this.echartsType8 = 15;
          break;
        case 16:
          this.echartsType8 = 16;
          break;
        case 17:
          this.echartsType9 = 17;
          break;
        case 18:
          this.echartsType9 = 18;
          break;
        case 19:
          this.echartsType10 = 19;
          break;
        case 20:
          this.echartsType10 = 20;
          break;
        case 21:
          this.echartsType11 = 21;
          break;
        case 22:
          this.echartsType11 = 22;
          break;
        case 23:
          this.echartsType12 = 23;
          break;
        case 24:
          this.echartsType12 = 24;
          break;
        case 25:
          this.echartsType13 = 25;
          break;
        case 26:
          this.echartsType13 = 26;
          break;
        case 27:
          this.echartsType14 = 27;
          break;
        case 28:
          this.echartsType14 = 28;
          break;
        case 29:
          this.echartsType15 = 29;
          break;
        case 30:
          this.echartsType15 = 30;
          break;
        case 31:
          this.echartsType16 = 31;
          break;
        case 32:
          this.echartsType16 = 32;
          break;
        case 33:
          this.echartsType17 = 33;
          break;
        case 34:
          this.echartsType17 = 34;
          break;
        case 35:
          this.echartsType18 = 35;
          break;
        case 36:
          this.echartsType18 = 36;
          break;
        case 37:
          this.echartsType19 = 37;
          break;
        case 38:
          this.echartsType19 = 38;
          break;
        case 39:
          this.echartsType20 = 39;
          break;
        case 40:
          this.echartsType20 = 40;
          break;
        case 41:
          this.echartsType21 = 41;
          break;
        case 42:
          this.echartsType21 = 42;
          break;
        case 43:
          this.echartsType22 = 43;
          break;
        case 44:
          this.echartsType22 = 44;
          break;
      }
    },
    // 点击查看更多
    seeMore50(value) {
      this.seeMore = true;
      if (value == 101) {
        this.tableData50 = this.appTop50;
        this.label50 = "专利申请量";
      } else if (value == 102) {
        this.tableData50 = this.authTop50;
        this.label50 = "专利授权量";
      } else if (value == 103) {
        this.tableData50 = this.validTop50;
        this.label50 = "有效发明量(累计)";
      } else if (value == 104) {
        this.tableData50 = this.notValidTop50;
        this.label50 = "无效发明量";
      } else if (value == 105) {
        this.tableData50 = this.pctTop50Count;
        this.label50 = "PCT公开量";
      } else if (value == 106) {
        this.tableData50 = this.topApp50Map;
        this.label50 = "申请量";
      } else if (value == 107) {
        this.tableData50 = this.topReg50Map;
        this.label50 = "注册量";
      } else if (value == 108) {
        this.tableData50 = this.topValid50Map;
        this.label50 = "有效注册量";
      } else if (value == 109) {
        this.tableData50 = this.tmTrfTop50;
        this.label50 = "商标转让量";
      } else if (value == 110) {
        this.tableData50 = this.tmLicTop50;
        this.label50 = "商标许可量";
      } else if (value == 111) {
        this.tableData50 = this.tmPldTop50;
        this.label50 = "商标质押量";
      } else if (value == 112) {
        this.tableData50 = this.madridTop50;
        this.label50 = "马德里注册量";
      }
    },
    // 关闭更多弹框
    closeMore() {
      this.seeMore = false;
    },
    // 申请量授权量切换
    applybtn(value) {
      // 直接修改echarts里data的数据
      switch (value) {
        case 1:
          this.numType1 = 1;
          break;
        case 3:
          this.numType2 = 3;
          break;
        case 5:
          this.numType3 = 5;
          break;
        case 9:
          this.numType4 = 9;
          break;
        case 11:
          this.numType5 = 11;
          break;
        case 14:
          this.numType6 = 14;
          break;
      }
    },
    agreebtn(value) {
      switch (value) {
        case 2:
          this.numType1 = 2;
          keyIndustries.domesticzl2sqind();
          break;
        case 4:
          this.numType2 = 4;
          break;
        case 6:
          this.numType3 = 6;
          break;
        case 15:
          this.numType6 = 15;
          break;
      }
    },
    yxfmbtn(value) {
      switch (value) {
        case 7:
          this.numType3 = 7;
          break;
      }
    },
    wxfmbtn(value) {
      switch (value) {
        case 8:
          this.numType3 = 8;
          break;
      }
    },
    regbtn(value) {
      switch (value) {
        case 10:
          this.numType4 = 10;
          break;
        case 12:
          this.numType5 = 12;
          break;
      }
    },
    yxregbtn(value) {
      switch (value) {
        case 13:
          this.numType5 = 13;
          break;
        case 16:
          this.numType6 = 16;
          break;
      }
    },
    // 滚动条监听事件
    scrollHandle() {
      let scrollObj = document.querySelector(".contentBack6"); // 获取滚动区域
      let clientHeight = scrollObj.clientHeight; // 容器的高度
      let scrollTop = scrollObj.scrollTop; // 已滚动的距离

      let echartsObj1 = document.querySelector("#ipcaaaaaa");
      let echartsHeight1 = echartsObj1.offsetTop; //当前表格离顶部的高度

      let echartsObj2 = document.querySelector("#PCTAnalyind");
      let echartsHeight2 = echartsObj2.offsetTop; //当前表格离顶部的高度

      let echartsObj3 = document.querySelector("#domesticsbAnalyind");
      let echartsHeight3 = echartsObj3.offsetTop; //当前表格离顶部的高度

      let echartsObj4 = document.querySelector("#mdlAnalyind");
      let echartsHeight4 = echartsObj4.offsetTop; //当前表格离顶部的高度
      if (
        clientHeight + scrollTop > echartsHeight1 - 100 &&
        this.firstscroll1
      ) {
        this.firstscroll1 = false;
        this.getPCTAndStatuszl();
      }
      if (
        clientHeight + scrollTop > echartsHeight2 - 100 &&
        this.firstscroll2
      ) {
        this.firstscroll2 = false;
        this.getGNsb();
      }
      if (
        clientHeight + scrollTop > echartsHeight3 - 100 &&
        this.firstscroll3
      ) {
        this.firstscroll3 = false;
        this.getmdlAndStatus();
      }
      if (
        clientHeight + scrollTop > echartsHeight4 - 100 &&
        this.firstscroll4
      ) {
        this.firstscroll4 = false;
        this.getYunysb();
      }
    },

    // 封装转换年季度时间格式的方法
    switchTime(value) {
      var e, y;
      if (value.toString().split("").length == 4) {
        value = value + "年";
      } else if (value.toString().split("").length == 5) {
        e = value.slice(-1);
        if (e == "1") {
          e = "第一季度";
        } else if (e == "2") {
          e = "第二季度";
        } else if (e == "3") {
          e = "第三季度";
        } else if (e == "4") {
          e = "第四季度";
        }
        y = value.slice(0, 4);
        value = y + "年" + e;
      }
      return value;
    },
    // 获取概况的方法
    getzl() {
      var that = this;
      this.$GET("/industry/analysis", {
        keyInd: that.indu,
        time: that.timevalueS,
        // time: "2019",
      }).then((res) => {
        // 存储概况数据
        that.count = res.data;
        ///////////////////////////////
        that.$store.commit("keyFirmdataszlind", res.data);
      });
    },
    //////////////////////////////////分接口获取数据////////////////////////////////////////////
    //1.国内专利分析、
    getGNzl() {
      this.$GET("/industry/domesticPtAly", {
        keyInd: this.indu,
        time: this.timevalueS,
        // time: "2019",
      }).then((res) => {
        this.$store.commit("keyGNzlind", res.data);
        // 国内专利趋势
        if (res.data.trendApList.length == 0) {
          this.havedata1 = false;
        } else {
          this.havedata1 = true;
          this.trendApList = res.data.trendApList;
          if (this.trendApList.length > 0) {
            this.trendApList.forEach((ele) => {
              ele.name = this.switchTime(ele.name);
            });
          }
        }

        // 专利类型构成
        if (res.data.apTyCount.length == 0) {
          this.havedata2 = false;
        } else {
          this.havedata2 = true;
          this.apTyCount = res.data.apTyCount;
        }
        if (res.data.apTyAuthCount.length == 0) {
          this.havedata3 = false;
        } else {
          this.havedata3 = true;
          this.apTyAuthCount = res.data.apTyAuthCount;
        }
        // IPC技术分类top10
        if (res.data.ipcCount.length == 0) {
          this.havedata4 = false;
        } else {
          this.havedata4 = true;
          this.ipcCount = res.data.ipcCount;
        }
        if (res.data.ipcAuthCount.length == 0) {
          this.havedata5 = false;
        } else {
          this.havedata5 = true;
          this.ipcAuthCount = res.data.ipcAuthCount;
        }
        // 专利分析榜单
        if (res.data.appTop10.length == 0) {
          this.havedata6 = false;
        } else {
          this.havedata6 = true;
          this.appTop10 = res.data.appTop10;
          this.appTop50 = res.data.appTop50;
        }
        if (res.data.authTop10.length == 0) {
          this.havedata7 = false;
        } else {
          this.havedata7 = true;
          this.authTop10 = res.data.authTop10;
          this.authTop50 = res.data.authTop50;
        }
        if (res.data.validTop10.length == 0) {
          this.havedata8 = false;
        } else {
          this.havedata8 = true;
          this.validTop10 = res.data.validTop10;
          this.validTop50 = res.data.validTop50;
        }
        if (res.data.notValidTop10.length == 0) {
          this.havedata9 = false;
        } else {
          this.havedata9 = true;
          this.notValidTop10 = res.data.notValidTop10;
          this.notValidTop50 = res.data.notValidTop50;
        }
        let loadingX = Loading.service({
          fullscreen: true,
          background: "rgba(0,0,0,0)",
          lock: true,
          text: "正在加载...",
        });
        setTimeout(() => {
          keyIndustries.domesticzl1ind();
          keyIndustries.domesticzl2ind();
          keyIndustries.domesticzl3ind();
          keyIndustries.domesticzl3sqind();
          keyIndustries.domesticzl4ind();
          keyIndustries.domesticzl4sqind();
          keyIndustries.domesticzl4yxind();
          keyIndustries.domesticzl4wxind();
          loadingX.close();
        }, 3000);
      });
    },
    getPCTAndStatuszl() {
      this.$GET("/industry/ptPctAly", {
        keyInd: this.indu,
        time: this.timevalueS,
        // time: "2018",
      }).then((res) => {
        this.$store.commit("PCTAndStatuszlind", res.data);
        // PCT专利趋势
        if (res.data.pctTrendCount.length == 0) {
          this.havedata10 = false;
        } else {
          
          this.havedata10 = true;
      
          this.pctTrendCount = res.data.pctTrendCount;
          if (this.pctTrendCount.length > 0) {
            this.pctTrendCount.forEach((item) => {
              item.name = this.switchTime(item.name);
            });
          }
        }

        // IPC分类top10
        if (res.data.pctIpcTop10.length == 0) {
          this.havedata11 = false;
        } else {
          this.havedata11 = true;
          this.pctIpcTop10 = res.data.pctIpcTop10;
        }

        // PCT公开量Top10
        if (res.data.pctTop10Count.length == 0) {
          this.havedata12 = false;
        } else {
          this.havedata12 = true;
          this.pctTop10Count = res.data.pctTop10Count;
          this.pctTop50Count = res.data.pctTop50Count;
        }
        // 专利状态分析
        if (res.data.ptLawCount.length == 0) {
          this.havedata13 = false;
        } else {
          this.havedata13 = true;
          this.ptLawCount = res.data.ptLawCount;
        }
        keyIndustries.pctzl1ind();
        keyIndustries.pctzl2ind();
        keyIndustries.pctzl3ind();
        keyIndustries.statuszlind();
      });
    },
    getGNsb() {
      this.$GET("/industry/domesticTmAly", {
        keyInd: this.indu,
        time: this.timevalueS,
        // time: "2018",
      }).then((res) => {
        this.$store.commit("keyGNsbind", res.data);
        // 国内商标趋势
        if (res.data.tmTrendMap.length == 0) {
          this.havedata14 = false;
        } else {
          this.havedata14 = true;
          this.tmTrendMap = res.data.tmTrendMap;
          if (this.tmTrendMap.length > 0) {
            this.tmTrendMap.forEach((ele) => {
              ele.name = this.switchTime(ele.name);
            });
          }
        }

        // 国际分类Top10

        if (res.data.icTop10Map.length == 0) {
          this.havedata15 = false;
        } else {
          this.havedata15 = true;
          this.icTop10Map = res.data.icTop10Map;
        }
        if (res.data.icRegTop10Map.length == 0) {
          this.havedata16 = false;
        } else {
          this.havedata16 = true;
          this.icRegTop10Map = res.data.icRegTop10Map;
        }
        // 商标分析榜单
        if (res.data.topApp10Map.length == 0) {
          this.havedata17 = false;
        } else {
          this.havedata17 = true;
          this.topApp10Map = res.data.topApp10Map;
          this.topApp50Map = res.data.topApp50Map;
        }
        if (res.data.topReg10Map.length == 0) {
          this.havedata18 = false;
        } else {
          this.havedata18 = true;
          this.topReg10Map = res.data.topReg10Map;
          this.topReg50Map = res.data.topReg50Map;
        }
        if (res.data.topValid10Map.length == 0) {
          this.havedata19 = false;
        } else {
          this.havedata19 = true;
          this.topValid10Map = res.data.topValid10Map;
          this.topValid50Map = res.data.topValid50Map;
        }

        keyIndustries.domesticsb1ind();
        keyIndustries.domesticsb2ind();
        keyIndustries.domesticsb2zcind();
        keyIndustries.domesticsb3ind();
        keyIndustries.domesticsb3zcind();
        keyIndustries.domesticsb3yxind();
      });
    },
    getmdlAndStatus() {
      this.$GET("/industry/tmMadridAndLawAly", {
        keyInd: this.indu,
        time: this.timevalueS,
        // time: "2018",
      }).then((res) => {
        this.$store.commit("mdlAndStatusind", res.data);
        //商标状态分析
        if(res.data.lawMap.length==0){
          this.havedata23=false
        }else{
          this.havedata23=true
          this.lawMap = res.data.lawMap;
        };
        if (res.data.madridTrend.length == 0) {
          this.havedata20 = false;
        } else {
          this.havedata20 = true;
          this.madridTrend = res.data.madridTrend;
          if (this.madridTrend.length > 0) {
            this.madridTrend.forEach((ele) => {
              ele.name = this.switchTime(ele.name);
            });
          }
        }
        if (res.data.madridExtendTop20.length == 0) {
          this.havedata21 = false;
        } else {
          this.havedata21 = true;
          let madridExtendTop20 = res.data.madridExtendTop20;
          this.madridExtendTop201 = madridExtendTop20.slice(0, 10);
          this.madridExtendTop202 = madridExtendTop20.slice(
            10,
            madridExtendTop20.length
          );
        }
        if (res.data.madridTop10.length == 0) {
          this.havedata22 = false;
        } else {
          this.havedata22 = true;
          this.madridTop10 = res.data.madridTop10;
          this.madridTop50 = res.data.madridTop50;
        }

        keyIndustries.mdl1ind();
        keyIndustries.mdl2ind();
        keyIndustries.mdl3ind();
        keyIndustries.statussbind();
      });
    },
    getYunysb() {
      this.$GET("/industry/tmOprAly", {
        keyInd: this.indu,
        time: this.timevalueS,
        // time: "2018",
      }).then((res) => {
        this.$store.commit("Yunysbind", res.data);
        // 商标转让趋势
        if (res.data.tmTransferMap.length == 0) {
          this.havedata24 = false;
        } else {
          this.havedata24 = true;
          this.tmTransferMap = res.data.tmTransferMap;
          if (this.tmTransferMap.length > 0) {
            this.tmTransferMap.forEach((ele) => {
              ele.name = this.switchTime(ele.name);
            });
          }
        }

        // 商标转让类别Top10
        if (res.data.tmIcTrfTop.length == 0) {
          this.havedata25 = false;
        } else {
          this.havedata25 = true;
          this.tmIcTrfTop = res.data.tmIcTrfTop;
        }

        // 商标许可趋势
        if (res.data.tmLicenseMap.length == 0) {
          this.havedata26 = false;
        } else {
          this.havedata26 = true;
          this.tmLicenseMap = res.data.tmLicenseMap;
          if (this.tmLicenseMap.length > 0) {
            this.tmLicenseMap.forEach((ele) => {
              ele.name = this.switchTime(ele.name);
            });
          }
        }

        // 商标许可类别Top10
        if (res.data.tmIcLicTop.length == 0) {
          this.havedata27 = false;
        } else {
          this.havedata27 = true;
          this.tmIcLicTop = res.data.tmIcLicTop;
        }

        // 商标质押趋势
        if (res.data.tmPledgeMap.length == 0) {
          this.havedata28 = false;
        } else {
          this.havedata28 = true;
          this.tmPledgeMap = res.data.tmPledgeMap;
          if (this.tmPledgeMap.length > 0) {
            this.tmPledgeMap.forEach((ele) => {
              ele.name = this.switchTime(ele.name);
            });
          }
        }

        // 商标质押类别Top10
        if (res.data.tmIcPldTop.length == 0) {
          this.havedata29 = false;
        } else {
          this.havedata29 = true;
          this.tmIcPldTop = res.data.tmIcPldTop;
        }
        // 商标运营分析榜单
        if (res.data.tmTrfTop10.length == 0) {
          this.havedata30 = false;
        } else {
          this.havedata30 = true;
          this.tmTrfTop10 = res.data.tmTrfTop10;
          this.tmTrfTop50 = res.data.tmTrfTop50;
        }
        if (res.data.tmLicTop10.length == 0) {
          this.havedata31 = false;
        } else {
          this.havedata31 = true;
          this.tmLicTop10 = res.data.tmLicTop10;
          this.tmLicTop50 = res.data.tmLicTop50;
        }
        if (res.data.tmPldTop10.length == 0) {
          this.havedata32 = false;
        } else {
          this.havedata32 = true;
          this.tmPldTop10 = res.data.tmPldTop10;
          this.tmPldTop50 = res.data.tmPldTop50;
        }

        keyIndustries.sbmani1ind();
        keyIndustries.sbmani2ind();
        keyIndustries.sbmani3ind();
        keyIndustries.sbmani4ind();
        keyIndustries.sbmani5ind();
        keyIndustries.sbmani6ind();
        keyIndustries.sbmani7ind();
        keyIndustries.sbmani7xkind();
        keyIndustries.sbmani7zyind();
      });
    },
    //////////////////////////////////////////////////////////////////////////////////////////
    // 导出更多
    daochu(value) {
      let aLink = document.createElement("a");
      aLink.href =
        this.$url +
        "/applicant/alyTopExport?token=" +
        localStorage.getItem("token") +
        "&uid=" +
        localStorage.getItem("uid") +
        "&keyInd=" +
        this.indu +
        "&time=" +
        this.timevalueS +
        "&key=" +
        value;
      aLink.click();
    },
  },
  created() {},
  mounted() {
 
    // 监听鼠标滚动
    let dom = document.getElementsByClassName("contentBack6")[0];
    if (dom) {
      dom.addEventListener("scroll", this.scrollHandle, true);
    }
    //   获取当前年
    let year = new Date().getFullYear();
    this.options[0].value = year;
    this.options[0].label = year + "年";
    this.options[1].value = year - 1;
    this.options[1].label = year - 1 + "年";
    // 获取当前季度
    // let season = Math.floor((new Date().getMonth() + 3) / 3);
    var arr = [];
    this.$set(arr, 0, year);
    this.$set(arr, 1, "");
    this.timevalue = arr;
    this.timevalueS = this.timevalue.join("");
    this.getzl();
    this.getGNzl();
    // let exportPDFtitle = this.indu + this.timevalueS
    // console.log('exportPDFtitle',exportPDFtitle)
  },

  destroyed() {
    window.removeEventListener("scroll", this.scrollHandle);
  },
};
</script>
<style>
.contentBack6 {
  background: rgba(0, 0, 0, 0) !important;
  overflow-y: auto;
  height: 100%;
}
.keyI .el-select {
    display: inline-block;
    position: relative;
    width: 100%;
}
</style>